import styled from 'styled-components';

export const Container = styled.div`
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Body = styled.div`
  border-radius: 8px;
  padding: 16px;
  box-shadow: 0px 1px 4px 0px #00000040;
  width: 540px;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #fff;
`;

export const Label = styled.div`
  font-size: 14px;
  color: #1a1b1c;
  width: 100%;
`;

export const Input = styled.input`
  padding: 8px;
  border-radius: 8px;
  border: 1px solid #e9edf1;
  width: 100%;
  font-size: 14px;
  text-align: start;
  color: #000;
`;

export const Button = styled.button`
  border: none;
  border-radius: 4px;
  background: #1371fe;
  padding: 8px 16px;
  color: #fff;
  font-size: 14px;
  width: 100%;
`;

export const Select = styled.select`
  padding: 8px;
  border-radius: 8px;
  border: 1px solid #e9edf1;
  width: 100%;
  font-size: 14px;
  text-align: start;
  color: #000;
`;

export const Error = styled.div`
  font-size: 12px;
  color: #f03;
  width: 100%;
`;

export const Account = styled.div`
  color: #1371fe;
  cursor: pointer;
  font-size: 12px;
  width: 100%;
`;
